<template>
  <div class="editBox">
    <button v-if="!btnHide" class="closeBtn" @click="$emit('edit')">
      <iconEdit v-if="icon==='edit'"/>
      <iconSave v-else/>
    </button>
    <div class="editBoxContent">
      <slot/>
    </div>
  </div>
</template>

<script>
import iconEdit from '../SVG/iconEdit'
import iconSave from '../SVG/iconSave'
export default {
  components: {
    iconEdit,
    iconSave
  },
  props: {
    icon: {
      type: String,
      default: 'edit'
    },
    btnHide: {
      type: Boolean,
      default: false
    }
  }

}
</script>

<style lang="scss" scoped>

.editBox {
  border: 1px solid var(--color-pri);
  width: 100%;
  height: fit-content;
  min-height: 169px;
  border-radius: 10px;
  position: relative;
  min-height: fit-content;
}
.closeBtn {
  margin: 0;
  padding: 0;
  position: absolute;
  top: 16px;
  right: 13px;
  width: 38px;
  height: 38px;
  border: none;
  background-color: transparent;
}
.editBoxContent {
  padding: 28px;
}
</style>
